import { useEffect, useState, useCallback } from "react"; // Fix 1: added useCallback

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import GlobalSearch from "./component";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import NoInternet from "../../NoInterNet/component";

const GlobalSearchContainer = (props) => {
  const { makeApiRequest } = useApiRequest();

  const navigate = useNavigate();

  const [loader, setLoader] = useState(true); // Fix 2: declared missing loader state
  const [flagMp, setFlagMp] = useState(true);
  const [globalSearchProName, setGlobalSearchProName] = useState("");
  const [vmwiseInventoryFlag, setVmwiseInventoryFlag] = useState(false);
  const [globalsearchTerm, setGlobalsearchTerm] = useState(null);
  const [globalvmList, setGlobalvmList] = useState([]);
  const [cartCount, setCartCount] = useState(null);
  const [carttotalAmount, setCarttotalAmount] = useState(null);
  const [ItemDetails, setItemDetails] = useState(null);
  const [MachineDetails, setMachineDetails] = useState(null);
  const [VmWiseInventroyList, setVmWiseInventroyList] = useState(null);
  const [PreCartListGlobal, setPreCartListGlobal] = useState(null);
  const [PreCartMachineID, setPreCartMachineID] = useState(null);
  const [CategoryDetails, setCategoryDetails] = useState(null);
  const [ActiveOrderItemsListGlobal, setActiveOrderItemsListGlobal] = useState();
  const [replaceCard, setReplceCard] = useState(false);
  const [slotId, setSlotdId] = useState(null);
  const [noInternet, setNoInternet] = useState(false);

  // ─── Network error handler ─────────────────────────────────────────────────

  const handleNetworkError = useCallback(
    (error) => {
      if (error.code === "ERR_NETWORK" || !error.response) {
        setNoInternet(true);
        setLoader(false);
        return true;
      }
      return false;
    },
    [] // Fix 1 (cont.): useCallback now resolves correctly
  );

  // ─── Online / offline listeners ───────────────────────────────────────────

  useEffect(() => {
    if (!navigator.onLine) {
      setNoInternet(true);
      setLoader(false);
    }

    const goOffline = () => setNoInternet(true);
    const goOnline = () => {
      setNoInternet(false);
      setLoader(true);
    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  // ─── Global search response handlers ──────────────────────────────────────

  const handleResponseGlobalSearch = (res, searchTerm) => {
    setCategoryDetails(res.data.data.categoryDetails);
    setItemDetails(res.data.data.itemDetails);
    setMachineDetails(res.data.data.machineDetails);
    setVmwiseInventoryFlag(false);
  };

  const handleErrorActiveOrders = (error) => {
     if (handleNetworkError(error)) return;
    // silent — no toast for global search errors
  };

  // ─── VM-wise inventory ─────────────────────────────────────────────────────

  const handleErrorVmWiseInventory = (error) => {
     if (handleNetworkError(error)) return;
    toast.error(`${error}`, {});
  };

  const handleResponseVmWiseInventory = (res) => {
    setVmWiseInventroyList(res.data.data);
    setVmwiseInventoryFlag(true);
    fetchPreCard();
    setFlagMp(false);
  };

  // ─── Navigation helpers ───────────────────────────────────────────────────

  const globalSearchflagBackbtn = (e) => {
    e.preventDefault();
    navigate("/");
  };

  const globalSearchflag = (e) => {
    e.preventDefault();
  };

  const backFromGlobalSearch = () => {
    setVmwiseInventoryFlag(false);
  };

  // ─── Initial data fetch ───────────────────────────────────────────────────

  useEffect(() => {
    globalSearch();
    fetchPreCard();
    fetchActiveOrder();
  }, []);

  // ─── Pre-cart totals ──────────────────────────────────────────────────────

  let totalitemcount = 0,
    totalAmount = 0;

  useEffect(() => {
    setCartCount(totalitemcount);
    setCarttotalAmount(totalAmount);
  }, [PreCartListGlobal]);

  // ─── Clear pre-cart ───────────────────────────────────────────────────────

  const handleErrorClearPreCard = (error) => {
     if (handleNetworkError(error)) return;
  };

  const handleResponseClearPreCard = (res) => {
    setReplceCard(false);
    addintoCart("tahzeev", slotId.sId, slotId.vmId, slotId.count);
    fetchPreCard();
    setReplceCard(false);
  };

  const fetchClearPreCard = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/cart`, // Fix 3: was 'URL' (uppercase)
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      data: {
        request: {},
      },
      handleSuccess: (res) => handleResponseClearPreCard(res),
      handleError: (error) => handleErrorClearPreCard(error),
    });
  };

  // ─── Global search ────────────────────────────────────────────────────────

  const globalSearch = (searchTerm) => {
    setVmwiseInventoryFlag(false);
    setGlobalSearchProName(searchTerm);
    setGlobalsearchTerm(searchTerm);

    if (globalSearchProName) {
      setGlobalSearchProName((prevValue) => prevValue.slice(0, -1));
    }

    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const lat = localStorage.getItem("lat");
    const lng = localStorage.getItem("lng");

    if (searchTerm) {
      // Fix 5: removed duplicate nested if(searchTerm) check
      makeApiRequest({
        url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/search/global?searchQuery=${searchTerm}&lat=${lat}&lng=${lng}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
        },
        handleSuccess: (res) => {
          handleResponseGlobalSearch(res, searchTerm);
        },
        handleError: (error) => handleErrorActiveOrders(error),
      });
    }
  };

  // ─── VM-wise inventory fetch ──────────────────────────────────────────────

  const vmWiseInvertory = (e, id, type, name) => {
    e.preventDefault();
    setGlobalSearchProName(name);

    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const lat = localStorage.getItem("lat");
    const lng = localStorage.getItem("lng");

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/outlet-wise/inventory?page=0&size=100&recentLimit=6&lat=${lat}&lng=${lng}&${type}=${id}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      data: {
        request: {},
      },
      handleSuccess: (res) => {
        handleResponseVmWiseInventory(res);
      },
      handleError: (error) => handleErrorVmWiseInventory(error),
    });
  };

  // ─── Add to cart ──────────────────────────────────────────────────────────

  const addintoCart = (e, sId, vmId, count, name, mrp) => {
    setSlotdId({ sId: sId, vmId: vmId, count: count });
    localStorage.setItem("Global_Slot_id", sId);

    const UserJWTAuth = localStorage.getItem("UserJWTAuth");

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/cart?machineId=${vmId}`,
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      data: [
        {
          slotId: parseInt(sId),
          count: count + 1,
        },
      ],
      handleSuccess: (res) => handleResponseAddToCart(res, vmId),
      handleError: (res) => handleErrorAddToCart(res),
    });
  };

  const handleErrorAddToCart = (res) => {
    toast.error(`${res.response.data.status.message}`, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
    });
    if (res.response.data.status.code !== "NOT_FOUND") {
      setReplceCard(true);
    }
  };

  const handleResponseAddToCart = (res, vmId) => {
    navigate(`/items?machineId=${vmId}&showItems=true`);
  };

  // ─── Set VM ───────────────────────────────────────────────────────────────

  const SetVm = (e, id, name, address) => {
    navigate(`/items?machineId=${id}&showItems=true`, { replace: true });
    localStorage.setItem("vmName", name);
    localStorage.setItem("vmAddress", address);
  };

  // ─── Pre-cart fetch ───────────────────────────────────────────────────────

  const fetchPreCard = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/cart`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      data: {},
      handleSuccess: (res) => handleResponsePreCardGlobal(res),
      handleError: (error) => handleErrorPreCardGlobal(error), // Fix 4 (part): pass error through
    });
  };

  const handleResponsePreCardGlobal = (res) => {
    setPreCartListGlobal(res.data.data);
  };

  const handleErrorPreCardGlobal = (error) => { // Fix 4: was () — missing error param
    if (error.response.status == 401 || error.response.status == 403) {
      navigate("/login");
    } else {
      toast.error(`${error.response.data.status.code}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    }
  };

  // ─── Active orders ────────────────────────────────────────────────────────

  const fetchActiveOrder = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/order/active`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      data: {},
      handleSuccess: (res) => handleResponseActiveOrdersGlobal(res),
      handleError: (res) => handleErrorActiveOrdersGlobal(res),
    });
  };

  const handleResponseActiveOrdersGlobal = (res) => {
    // response intentionally unused for now
  };

  const handleErrorActiveOrdersGlobal = (res) => {
    // no toast: failing to load active orders shouldn't interrupt search
  };

  if (noInternet) return <NoInternet />;

  // ─── Remove from cart ─────────────────────────────────────────────────────

  const removefromCart = (e, slotId, vmId, count) => {
    navigate(`/items?machineId=${vmId}&showItems=true`);
  };

  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <>
      <GlobalSearch
        globalSearch={globalSearch}
        globalSearchProName={globalSearchProName}
        globalSearchflagBackbtn={globalSearchflagBackbtn}
        globalSearchflag={globalSearchflag}
        CategoryDetails={CategoryDetails}
        ItemDetails={ItemDetails}
        MachineDetails={MachineDetails}
        globalsearchTerm={globalsearchTerm}
        vmwiseInventoryFlag={vmwiseInventoryFlag}
        globalvmList={globalvmList}
        vmWiseInvertory={vmWiseInvertory}
        VmWiseInventroyList={VmWiseInventroyList}
        addintoCart={addintoCart}
        PreCartListGlobal={PreCartListGlobal}
        ActiveOrderItemsListGlobal={ActiveOrderItemsListGlobal}
        cartCount={cartCount}
        carttotalAmount={carttotalAmount}
        PreCartMachineID={PreCartMachineID}
        removefromCart={removefromCart}
        SetVm={SetVm}
        backFromGlobalSearch={backFromGlobalSearch}
        fetchClearPreCard={fetchClearPreCard}
        replaceCard={replaceCard}
        setReplceCard={setReplceCard}
        setFlagMp={setFlagMp}
        flagMp={flagMp}
      />
    </>
  );
};

export default GlobalSearchContainer;